<div class="data">
    <div class="data__value mtv-primary-color" (click)="toggleDetails()">
        {{value}}
    </div>
    <div class="data__details" [class.active]="isShow">
        <div class="wrapper">
            <ul *ngFor="let item of data" class="list-unstyled">
                <li>{{item}}</li>
            </ul>
        </div>
    </div>
</div>



// WEBPACK FOOTER //
// /app/src/app/components/relation-list/relation-list.component.html